/**
 * Thin progress bar displayed during file upload in the attachment area.
 */
import { type FC, memo, type ReactNode } from 'react'

import { Progress } from '@/components/ui/progress'
import { cn } from '@/lib/utils'

export interface ChatInputUploadProgressProps {
  progress: number
  className?: string
}

const ChatInputUploadProgressBase: FC<ChatInputUploadProgressProps> = ({
  progress,
  className,
}): ReactNode => (
  <div className={cn('chat-input-upload-progress w-full px-1', className)}>
    <Progress value={progress} className="h-1.5 w-full" />
    <p className="mt-1 text-center text-xs text-muted-foreground">
      Uploading... {Math.round(progress)}%
    </p>
  </div>
)

export const ChatInputUploadProgress = memo(ChatInputUploadProgressBase)

ChatInputUploadProgress.displayName = 'ChatInputUploadProgress'
